/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Why_Listening_Advantage_DevicesInputs */

const en_why_listening_advantage_devices = /** @type {(inputs: Why_Listening_Advantage_DevicesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Every device, even your car`)
};

const es_why_listening_advantage_devices = /** @type {(inputs: Why_Listening_Advantage_DevicesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Todos tus dispositivos, incluso el coche`)
};

/**
* | output |
* | --- |
* | "Every device, even your car" |
*
* @param {Why_Listening_Advantage_DevicesInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const why_listening_advantage_devices = /** @type {((inputs?: Why_Listening_Advantage_DevicesInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Why_Listening_Advantage_DevicesInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_why_listening_advantage_devices(inputs)
	return en_why_listening_advantage_devices(inputs)
});